export const replaceAllData = (text, replaceText, replaceWith) => {
  return text.replaceAll(replaceText, replaceWith);
};

export const highlightSearchData = (text, replaceText) => {
  const regEx = new RegExp(replaceText, "ig");
  return text.replace(regEx, (match) => `<span style="font-weight:400!important;">${match}</span>`);
};
